<template>
<loader v-bind="{ loading }">
  <div class="tabs">
    <ul>
      <router-link custom v-slot="{ navigate }" :to="{ name: 'checkpoint-manager', params: { checkpoint: $route.params.checkpoint }}">
        <li @click="navigate">
          <a>Standards</a>
        </li>
      </router-link>
      <router-link custom v-slot="{ navigate }" :to="{ name: 'checkpoint-assessor', params: { checkpoint: $route.params.checkpoint }}">
        <li @click="navigate">
          <a>Assessor</a>
        </li>
      </router-link>
      <router-link custom v-slot="{ navigate }" :to="{ name: 'checkpoint-edit', params: { checkpoint: $route.params.checkpoint }}">
        <li @click="navigate">
          <a>Edit</a>
        </li>
      </router-link>
    </ul>
  </div>
  <router-view />
</loader>
</template>  
<script>
export default {

  data: () => ({
    loading: false
  }),
  
  beforeCreate() {
    Promise.all([
      this.$store.dispatch('checkpoint/loadCheckpoint', this.$route.params.checkpoint)
    ]).then(() => {
      this.loading = false
    })
  },

}
</script>